import React, { useState, useEffect } from "react";
import { UseAdvContract } from "./UseAdvContract";
import {
  Autocomplete,
  TextField,
  Box,
  IconButton,
  InputAdornment,
  Button,
} from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function AdvContractAutoComplete(props) {
  const { getAdvContractListCombo, getAdvContractByID } = UseAdvContract();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (props.selectedContractID) {
      getAdvContractByID(props.selectedContractID, (advs) => {
        setSelectedOption(advs);
      });
    }
  }, [props.selectedContractID]);

  const handleSearch = () => {
    const query = searchText.trim();
    if (query.length > 0) {
      setProgress(true);
      getAdvContractListCombo(query, (res) => {
        setOptions(res.contract || []);
      });
    } else {
      setOptions([]);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: props.contract && "100%",
        gap: 2,
      }}
    >
      <Autocomplete
        options={options}
        value={selectedOption}
        onChange={(event, newValue) => {
          if (newValue) {
            setSelectedOption(newValue);
            props.onSelect?.(newValue?.id);
          } else {
            setSelectedOption();
            props.onSelect?.();
          }
        }}
        fullWidth
        getOptionLabel={(option) =>
          option?.customer ? option.id + " - " + option.customer : ""
        }
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        renderInput={(params) => (
          <TextField
            {...params}
            label="جستجوی قرارداد"
            error={props.errorState}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.stopPropagation();
                handleSearch();
              }
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {searchText && (
                    <InputAdornment position="end">
                      <Button size="small" onClick={handleSearch}>
                        جستجو
                      </Button>
                    </InputAdornment>
                  )}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            placeholder="نام مشتری را وارد کنید"
          />
        )}
      />
      <IconButton sx={{ p: 0 }} href="/advertismentcontract" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
